
import Vue, { ComponentOptions } from "vue";
import Component, { mixins } from "vue-class-component";
import {
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Watch,
} from "vue-property-decorator";

import { Memoize } from "lodash-decorators";

import * as moment from "moment";

import { WebAPI } from "../web-api";

import { CopyToClipboard } from '../clipboard-mixin';

import { LaxySharingLink } from "../types";

@Component({
  filters: {},
})
export default class SharingLinkList extends mixins(CopyToClipboard) {
  @Prop({ type: String })
  public jobId: string;

  @Prop({ type: Array })
  public sharingLinks: LaxySharingLink[];

  @Prop({ type: Boolean, default: true })
  public showDeleteButton: boolean;

  @Prop({ type: Boolean, default: true })
  public allowExpiryEdit: boolean;

  @Prop({ type: Boolean, default: true })
  public showCurlHelper: boolean;

  public showCurlInfo = false;
  
  private _days = 24 * 60 * 60; // seconds in a day
  public access_token_lifetime_options: any[] = [
    1 * this._days,
    2 * this._days,
    7 * this._days,
    30 * this._days,
    "Never (∞)",
  ];

  formatSharingLink(link: LaxySharingLink) {
    const rel = `#/job/${link.object_id}/?access_token=${link.token}`;
    return this.relToFullLink(rel);
  }

  relToFullLink(rel_link: string) {
    const tmp_a = document.createElement("a") as HTMLAnchorElement;
    tmp_a.href = rel_link;
    const abs_link = tmp_a.href;
    return abs_link;
  }

  @Memoize((link: LaxySharingLink) => link.id)
  linkIsExpired(link: LaxySharingLink) {
    return moment(link.expiry_time).isBefore(Date.now());
  }

  formatExpiryString(expiry_time: Date | null, add_sentence_words?: boolean) {
    if (expiry_time == null) {
      if (add_sentence_words) {
        return ", never expires";
      } else {
        return "Never";
      }
    }
    const m = moment(expiry_time);
    let suffix = "from now";
    if (m.isBefore(Date.now())) {
      suffix = "ago";
    }
    let formatted = `${m.fromNow(true)} ${suffix} on ${m.format(
      "DD-MMM-YYYY (HH:mm UTCZ)"
    )}`;
    if (add_sentence_words) {
      formatted = ` until ${formatted}`;
    }
    return formatted;
  }

  tarballUrl(link: LaxySharingLink): string {
    return WebAPI.downloadJobTarballUrl(this.jobId, link.token);
  }

  formatCurlCli(link: LaxySharingLink) {
    return `curl "${this.tarballUrl(link)}" >${this.jobId}.tar.gz`
  }

  async updateSharingLink(job_id: string, expires_in: number | string) {
    this.$emit("change-link", { job_id: job_id, expires_in: expires_in });
  }

  async deleteSharingLink(link_id: string) {
    this.$emit("delete-link", link_id);
  }
}
